import { IProduct } from '../../../IProduct';
import { P00039DataRxTxIndex } from '../../P00039Sync';
import { getPoolMasterClass } from '../../../../ECoSystemsHelper';
import { Pool } from '../../../../../../apis/pool.api';

export function P00062InstallationFinish(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  const master = getPoolMasterClass(pool);
  const presence = master?.hasProduct(pool, productClass) ?? 0;
  editValue(
    P00039DataRxTxIndex.PACPOLY_Installation,
    'ppIConfigurationProduit',
    presence != 0,
    null,
    productClass,
  );
}
